import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const AddMarcaEqu2 = ({styles, handleSubmit, handleChange, args, errors}) => {
    return(
        <div>
            <button className="ui right labeled icon button" style={styles.titBuscar}>
                <i className="large plus yellow icon"></i>
                Marca nueva
            </button>
            <div style={styles.box}>
                <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
                    <div className="ui one column stackable grid">
                        <div className="row container">
                            <div className="column" width="100%">
                                <Form.Field>
                                    <label style={styles.label}>Código</label>
                                    <Form.Input autoComplete="off" name="codigoMarcaEqu" id="codigoMarcaEqu" onChange={handleChange} placeholder='Código' icon={!errors.length?null: _find(errors, {path:'codigoMarcaEqu'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>
                                <Form.Field>
                                    <label style={styles.label}>Descripción</label>
                                    <Form.Input autoComplete="off" name="descrMarcaEqu" id="descrMarcaEqu" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrMarcaEqu'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                                </Form.Field>

                                <Button style={styles.confirmar} type='submit' fluid>
                                    AGREGAR
                                </Button>

                                {
                                    errors.length?<Message negative header="Los siguientes errores:"
                                    list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                                }
                            </div>
                        </div>
                    </div>
                </Form>
            </div>
        </div>
    )
}

export default AddMarcaEqu2
